import React from 'react';
import SurveyInstanceNotifView from '@src/components/survey/view/SurveyInstanceNotifView';

const SurveyInstanceNotifPage = () => <SurveyInstanceNotifView />;

export default SurveyInstanceNotifPage as any;